import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.dataStatistics.loading;
export const selectErrorMessage = (state: RootState) =>
  state.dataStatistics.error;
export const dataStatisticsResponse = (state: RootState) =>
  state.dataStatistics.dataStatisticsResponse;
